// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';
import TranslationOfTextContentSchema from './translation-of-text-content-schema';

const schema = {
  $id: '/update-text-content-request-schema',
  type: 'object',
  required: ['id', 'creatorId', 'id'],
  properties: {
    id: {
      type: 'integer',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    creatorId: {
      type: 'integer',
    },
    creatorName: {
      type: 'string',
      nullable: true,
    },
    created: {
      type: 'string',
      format: 'date-time',
    },
    modifierId: {
      type: 'integer',
      nullable: true,
    },
    modifierName: {
      type: 'string',
      nullable: true,
    },
    modified: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    textContentKey: {
      type: 'string',
      nullable: true,
    },
    scope: {
      type: 'string',
      nullable: true,
    },
    originalContent: {
      type: 'string',
      nullable: true,
    },
    originalLanguage: {
      type: 'string',
      nullable: true,
    },
    translations: {
      type: 'array',
      nullable: true,
      items: { ...TranslationOfTextContentSchema },
    },
  },
} as IJSONSchema;

export default schema;
